import { render, staticRenderFns } from "./OrderPropertyValueListItem.vue?vue&type=template&id=905d838e&"
import script from "./OrderPropertyValueListItem.vue?vue&type=script&lang=js&"
export * from "./OrderPropertyValueListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielkaschlaw/Desktop/Sites/devTools_shit/27534/45/KloeppingVueTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('905d838e')) {
      api.createRecord('905d838e', component.options)
    } else {
      api.reload('905d838e', component.options)
    }
    module.hot.accept("./OrderPropertyValueListItem.vue?vue&type=template&id=905d838e&", function () {
      api.rerender('905d838e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/OrderPropertyValueListItem.vue"
export default component.exports